import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ImagilityBaseResponse } from 'app-models';

@Injectable({
  providedIn: 'root'
})
export class AttorneySendInviteDialogLibraryService {
  constructor(
    private httpClient: HttpClient
  ) { }

  sendInviteToAttorneyCreatedEmpBene(companyId, payload) {
    return this.httpClient.post(`/attorneySendInviteToEmployementTypeBeneficiary/${companyId}`, payload);
  }

  //  checkIsInvited(beneficiaryId: number, companyId: number) 

  checkIsInvited(beneficiaryId: number, companyId) { 
    return this.httpClient.post(`/petitionerSendInviteToBeneficiary/${beneficiaryId}/${companyId}`, {}).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  } 
   
  sendInviteToAttorneyforcetoupdate(beneficiaryId, companyId) {  
    return this.httpClient.post(`/petitionerSendInviteToBeneficiary/forcetoupdate/${beneficiaryId}/${companyId}`, {}).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  }

  getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  getUserName(nameList: any[]): string{
    let username = '';
    
    //Get Random name
    username = nameList[Math.floor(Math.random() * nameList.length)].toLowerCase().trim();

    // If length is grated than 10
    if(username.length > 10){
      username = username.substring(0,9);
    }

    //Append 2 digits
    username += this.getRndInteger(11,99);

    if(username.length < 5){
      username = this.getUserName(nameList);
    }

    //First letter capital
    const [firstLetter, ...rest] = username.split("");
    username = firstLetter.toUpperCase() + rest.join("");

    return username;
  }
}
